import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAuNA8iXF9AsigFuFCp7CLOUheVWwrXSBQ",
  authDomain: "identity-b5834.firebaseapp.com",
  projectId: "identity-b5834",
  storageBucket: "identity-b5834.firebasestorage.app",
  messagingSenderId: "449024980914",
  appId: "1:449024980914:web:13be1231fa625d588016ab",
  measurementId: "G-MY5MLEY09E"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
